// 
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React from 'react';

// 
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const NotFound = () => {
  // 
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return (
    <div></div>
  );
};

export default NotFound;